/**
 * Copyright 2022 Design Barn Inc.
 */

const serializeQueryParams = (obj: Record<string, string>): string => {
  const str = Object.keys(obj)
    .reduce<string[]>((acc, key) => {
      if (obj[key]) {
        acc.push(`${key}=${encodeURIComponent(obj[key] || '')}`);
      }

      return acc;
    }, [])
    .join('&');

  return str;
};

export default serializeQueryParams;
